import Empty from './emptyLayout';
import Regular from './regularLayout';

export const PageLayout = { Regular, Empty };

export default PageLayout;
export type { BreadcrumbLink, PageAction, RenderBreadcrumbLink } from './types';
export { PageActions } from './regularLayout';
export type { PageContentGap, RegularLayoutProps } from './regularLayout';
export type { EmptyLayoutProps } from './emptyLayout';
